import { motion } from 'framer-motion';
import React, { useState } from 'react';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Overview', id: 'home' },
    { name: 'Strategy', id: 'about' },
    { name: 'Deployments', id: 'projects' },
    { name: 'Insights', id: 'blogs' },
    { name: 'Tech Stack', id: 'skills' },
    { name: 'Connect', id: 'connect' },
  ];

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-[100] px-6 py-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-8 py-4 bg-transparent backdrop-blur-md rounded-full border-none">
        <button
          onClick={() => scrollTo('home')}
          className="flex items-center gap-6 group"
        >
          <img src={logo} alt="Ramspheld Logo" className="h-12 md:h-14 w-auto group-hover:scale-110 transition-transform duration-300" />
          <span className="hidden sm:inline-block text-xl font-black text-white group-hover:text-primary transition-colors tracking-widest">
            RAMSPHELD<span className="text-primary truncate">.DEV</span>
          </span>
        </button>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-10">
          {navItems.map((item) => (
            <button
              key={item.name}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-semibold text-gray-400 hover:text-white transition-colors relative group"
            >
              {item.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all group-hover:w-full" />
            </button>
          ))}
          <button
            onClick={() => scrollTo('connect')}
            className="px-6 py-2 bg-primary text-white text-sm font-bold rounded-full hover:scale-105 transition-transform"
          >
            Hire/Collaborate
          </button>
        </div>

        {/* Mobile Navigation Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            {isOpen ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />}
          </svg>
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="md:hidden mt-4 glass-card rounded-3xl p-6 mx-auto max-w-sm"
        >
          <div className="flex flex-col space-y-4">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollTo(item.id)}
                className="text-lg font-medium text-gray-300 hover:text-white"
              >
                {item.name}
              </button>
            ))}
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;
